import React, { useEffect, useRef, useState } from 'react';
import { useLang } from '../LanguageProvider';
import { urunMetinleri } from './urunMetinleri';

/**
 * CRM ANİMASYONU — crm-whowsell/src/components/landing/ProfitCard.tsx PORTU
 *
 * NE YAPAR: "Öncesi / WhowSell ile" karşılaştırmalı satış grafiği. İmleçli
 * cihazlarda karta gelince, dokunmatikte karta dokununca çubuk grafik kayar,
 * çizgi soldan sağa açılır, rozet "Öncesi"nden "WhowSell ile"ye geçer.
 * Sayfa DAİMA "öncesi" hâliyle açılır (kaynaktaki kural aynen korundu).
 *
 * KAYNAK DOSYALARA GÖRE FARKLAR VE GEREKÇELERİ:
 *
 * 1) `Visual1` yerine yalnızca `Layer1` + `Layer2` taşındı. GEREKÇE: kaynakta
 *    çağrı `overlay={false} grid={false} glow={false}` ile yapılıyor, yani
 *    `Layer3`, `Layer4`, `EllipseGradient` ve `GridLayer` HİÇ ÇİZİLMİYOR.
 *    Taşınmayan katmanlar zaten ekranda görünmeyen katmanlardır.
 *    `mainColor="#ff6900"`, `secondaryColor="#f54900"` birebir korundu.
 *
 * 2) TAILWIND ADLI GRUP (`group/animated-card` + `group-hover/animated-card:`)
 *    yerine kendi sınıflarım kullanıldı (`.wh-crm-profit` / `.wh-crm-layer1`).
 *    GEREKÇE: kaynağın `is-touch-on` kuralları Tailwind'in ürettiği kaçışlı
 *    sınıf adlarını (`.group-hover\/animated-card\:translate-x-\[-50\%\]`)
 *    hedefliyordu; bu, Tailwind'in üretim biçimine bağlı kırılgan bir bağdır.
 *    Sonuç GÖRSEL OLARAK AYNIDIR: aynı `translateX(-50%)`, aynı 500ms süre,
 *    aynı `cubic-bezier(0.6, 0.6, 0, 1)`, aynı `@media (hover: hover) and
 *    (pointer: fine)` kapısı.
 *
 * 3) `v2.css`'teki `.crm-profit*` kuralları `App.css`'e `.wh-crm-` önekiyle
 *    taşındı; ölçüler, renkler ve süreler değişmedi. `--crm-*` değişkenleri
 *    ana sitenin iki temasına bağlandı (aşağıdaki App.css bloğuna bakınız),
 *    böylece kart açık ve koyu temada da okunur.
 *
 * 4) `useI18n` (7 dil) yerine ana sitenin `useLang` (tr/en) kaynağı + yerel
 *    sözlük. `translations.js` içerik ajanının dosyası olduğu için ona
 *    dokunulmadı.
 */

const ART_W = 356;
const ART_H = 180;

/* Kaynak: animated-card.tsx -> Layer1. Çubuk grafik; hover/dokunuşta sola kayar. */
function Layer1({ color, secondaryColor }) {
  return (
    <div className="wh-crm-layer1 absolute top-0 left-0 z-[6]">
      <svg className="w-[712px]" viewBox="0 0 712 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 178C8 176.343 9.34315 175 11 175H25C26.6569 175 28 176.343 28 178V196H8V178Z" fill={color} />
        <path d="M32 168C32 166.343 33.3431 165 35 165H49C50.6569 165 52 166.343 52 168V196H32V168Z" fill={secondaryColor} />
        <path d="M67 173C67 171.343 68.3431 170 70 170H84C85.6569 170 87 171.343 87 173V196H67V173Z" fill={color} />
        <path d="M91 153C91 151.343 92.3431 150 94 150H108C109.657 150 111 151.343 111 153V196H91V153Z" fill={secondaryColor} />
        <path d="M126 142C126 140.343 127.343 139 129 139H143C144.657 139 146 140.343 146 142V196H126V142Z" fill={color} />
        <path d="M150 158C150 156.343 151.343 155 153 155H167C168.657 155 170 156.343 170 158V196H150V158Z" fill={secondaryColor} />
        <path d="M187 133C187 131.343 188.343 130 190 130H204C205.657 130 207 131.343 207 133V196H187V133Z" fill={color} />
        <path d="M211 161C211 159.343 212.343 158 214 158H228C229.657 158 231 159.343 231 161V196H211V161Z" fill={secondaryColor} />
        <path d="M248 150C248 148.343 249.343 147 251 147H265C266.657 147 268 148.343 268 150V196H248V150Z" fill={color} />
        <path d="M272 130C272 128.343 273.343 127 275 127H289C290.657 127 292 128.343 292 130V196H272V130Z" fill={secondaryColor} />
        <path d="M307 133C307 131.343 308.343 130 310 130H324C325.657 130 327 131.343 327 133V196H307V133Z" fill={color} />
        <path d="M331 155C331 153.343 332.343 152 334 152H348C349.657 152 351 153.343 351 155V196H331V155Z" fill={secondaryColor} />
        <path d="M363 161C363 159.343 364.343 158 366 158H380C381.657 158 383 159.343 383 161V196H363V161Z" fill={color} />
        <path d="M387 144C387 142.343 388.343 141 390 141H404C405.657 141 407 142.343 407 144V196H387V144Z" fill={secondaryColor} />
        <path d="M423 126C423 124.343 424.343 123 426 123H440C441.657 123 443 124.343 443 126V196H423V126Z" fill={color} />
        <path d="M447 142C447 140.343 448.343 139 450 139H464C465.657 139 467 140.343 467 142V196H447V142Z" fill={secondaryColor} />
        <path d="M483 125.461C483 124.102 484.343 123 486 123H500C501.657 123 503 124.102 503 125.461V196H483V125.461Z" fill={color} />
        <path d="M507 137.507C507 136.122 508.343 135 510 135H524C525.657 135 527 136.122 527 137.507V196H507V137.507Z" fill={secondaryColor} />
        <path d="M543 108.212C543 106.438 544.343 105 546 105H560C561.657 105 563 106.438 563 108.212V196H543V108.212Z" fill={color} />
        <path d="M567 116.485C567 115.112 568.343 114 570 114H584C585.657 114 587 115.112 587 116.485V196H567V116.485Z" fill={secondaryColor} />
        <path d="M603 79.8333C603 78.2685 604.343 77 606 77H620C621.657 77 623 78.2685 623 79.8333V196H603V79.8333Z" fill={color} />
        <path d="M627 91.8919C627 90.2947 628.343 89 630 89H644C645.657 89 647 90.2947 647 91.8919V196H627V91.8919Z" fill={secondaryColor} />
        <path d="M661 66.7887C661 65.2485 662.343 64 664 64H678C679.657 64 681 65.2485 681 66.7887V196H661V66.7887Z" fill={color} />
        <path d="M685 55.7325C685 54.2233 686.343 53 688 53H702C703.657 53 705 54.2233 705 55.7325V196H685V55.7325Z" fill={secondaryColor} />
      </svg>
    </div>
  );
}

/* Kaynak: animated-card.tsx -> Layer2. Trend çizgisi; clip-path ile soldan açılır. */
function Layer2({ color }) {
  return (
    <div className="absolute top-0 left-[-1px] h-full w-[356px]">
      <svg className="wh-crm-visual-line h-full w-[356px]" viewBox="0 0 356 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#wh_crm_clip0_25_384)">
          <path
            d="M1 131.5L33.5 125.5L64 102.5L93.5 118.5L124.5 90L154 100.5L183.5 76L207.5 92L244.5 51L274.5 60.5L307.5 46L334.5 28.5L356.5 1"
            stroke={color}
          />
          <path
            d="M33.5 125.5L1 131.5V197H356.5V1L335 28.5L306.5 46L274.5 60.5L244.5 51L207.5 92L183.5 76L154 100.5L124.5 90L93.5 118.5L64 102.5L33.5 125.5Z"
            fill={color}
            fillOpacity="0.3"
          />
        </g>
        <defs>
          <clipPath id="wh_crm_clip0_25_384">
            <rect width="356" height="180" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default function CrmProfitCard() {
  const { lang } = useLang();
  const m = urunMetinleri(lang).crm;
  const artRef = useRef(null);
  const [scale, setScale] = useState(1);
  /* Sayfa DAİMA "öncesi" hâliyle açılır. Bu değeri kullanıcının kendi
     dokunuşundan/klavyesinden başka hiçbir şey değiştiremez. */
  const [touchOn, setTouchOn] = useState(false);

  useEffect(() => {
    const art = artRef.current;
    if (!art) return undefined;

    const measure = () => {
      const width = art.clientWidth;
      if (!width) return;
      setScale(width / ART_W);
    };

    measure();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    if (observer) observer.observe(art);
    window.addEventListener('resize', measure);
    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  return (
    <div className={touchOn ? 'wh-crm-profit is-touch-on' : 'wh-crm-profit'}>
      <div className="wh-crm-profit-legend" aria-hidden="true">
        <span className="wh-crm-profit-chip before">
          <i />
          {m.oncesiRozet}
        </span>
        <span className="wh-crm-profit-chip after">
          <i />
          {m.sonrasiRozet}
        </span>
      </div>

      <div className="wh-crm-profit-tip" aria-hidden="true">
        <strong>{m.sonrasiBaslik}</strong>
        <span>{m.sonrasiMetin}</span>
      </div>

      <div ref={artRef} className="wh-crm-profit-art" style={{ height: ART_H * scale }}>
        <div
          className="wh-crm-profit-art-inner"
          style={{ width: ART_W, height: ART_H, transform: `scale(${scale})` }}
        >
          <div aria-hidden className="relative h-full w-full overflow-hidden">
            <Layer1 color="#ff6900" secondaryColor="#f54900" />
            <Layer2 color="#ff6900" />
          </div>
        </div>

        {/* DOKUNMA HEDEFİ. Gerçek bir <button> olduğu için klavyeyle de
            (Sekme + Enter/Boşluk) çalışır ve durum `aria-pressed` ile ekran
            okuyuculara bildirilir. İmleçli cihazlarda CSS ile tamamen kaldırılır
            (display: none), yani PC'de tek bir olay dinleyicisi bile devreye girmez. */}
        <button
          type="button"
          className="wh-crm-profit-tetik"
          aria-pressed={touchOn}
          aria-label={m.ipucuDokunma}
          onClick={() => setTouchOn((acik) => !acik)}
        />
      </div>

      <div className="wh-crm-profit-copy">
        <h3 className="wh-crm-profit-title">{m.oncesiBaslik}</h3>
        <p className="wh-crm-profit-text">{m.oncesiMetin}</p>
        {/* İki metin de basılır, hangisinin görüneceğine CSS medya sorgusu
            karar verir. JS ile seçilseydi ilk karede yanlış metin görünürdü. */}
        <span className="wh-crm-profit-hint">
          <span className="wh-crm-profit-hint-hover">{m.ipucuHover}</span>
          <span className="wh-crm-profit-hint-touch">{m.ipucuDokunma}</span>
        </span>
      </div>
    </div>
  );
}
